import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { compress } from 'lz-string';
import { BehaviorSubject, startWith, map, combineLatest } from 'rxjs';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
	selector: 'app-customer-information-override-modal',
	template: `
		<h1 mat-dialog-title>Customer Information Override</h1>
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div mat-dialog-content>
				<div class="grid">
					<mat-form-field appearance="fill" style="position:sticky;top:0;background:white;z-index:1;">
						<mat-label>Search Property</mat-label>
						<input matInput [formControl]="searchControl" cdkFocusInitial />
						<mat-hint>Press '/' to fill empty fields with placeholder values</mat-hint>
					</mat-form-field>
					<cdk-virtual-scroll-viewport itemSize="70.06" class="example-viewport custom-scrollbar">
						<mat-form-field appearance="fill" *cdkVirtualFor="let row of displayedValues$; templateCacheSize: 0">
							<mat-label>{{ row.header }}</mat-label>
							<input matInput [placeholder]="'' + row.value" (keydown)="handleFillValueIfEmpty($event, row.header, row.value)" [formControlName]="row.header" />
						</mat-form-field>
					</cdk-virtual-scroll-viewport>
				</div>
			</div>
			<div mat-dialog-actions>
				<button mat-button type="button" (click)="onNoClick()">Cancel</button>
				<button mat-button type="submit">Ok</button>
			</div>
		</form>
	`,
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, FormsModule, MaterialModule, ScrollingModule],
	styles: [
		`
			.example-viewport {
				min-height: 50vh;
			}
		`,
	],
})
export class CustomerInformationOverrideModalComponent {
	constructor(
		public dialogRef: MatDialogRef<CustomerInformationOverrideModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private _ss: StoreService,
		private _fb: FormBuilder,
		private _bottomPopup: BottomPopupService,
	) {}

	headers = Object.keys(this.data);
	values: (string | number | null)[] = Object.values(this.data);

	searchControl = new FormControl('', { nonNullable: true });

	headersAndValues$ = new BehaviorSubject(this.headers.map((header, i) => ({ header, value: this.values[i] })));

	displayedValues$ = combineLatest([this.searchControl.valueChanges.pipe(startWith('')), this.headersAndValues$]).pipe(
		map(([search, values]) => {
			if (!search) return [...values];

			return [...values].filter(({ header, value }) => {
				const searchRegex = new RegExp(search, 'i');

				return searchRegex.test(header) || searchRegex.test(value as string);
			});
		}),
	);

	form = this._fb.nonNullable.group(this.headers.reduce((acc, curr, i) => ({ ...acc, [curr]: [<string>null] }), {}));

	onNoClick(): void {
		this.dialogRef.close();
	}

	onSubmit() {
		const newValues = this.form.value;
		for (const key in newValues) {
			if (!newValues[key]) {
				newValues[key] = this.data[key];
			}
		}
		this._ss.CustomerInformation = this.form.value;
		const compressed = compress(JSON.stringify(this.form.value));
		localStorage.setItem('CustomerInformation', compressed);

		console.log(this.form.value);

		this._bottomPopup.show('Customer Information Saved', { action: 'Ok', forgetDefaultOptions: true, options: { duration: 2000 } });
		this.dialogRef.close();
	}

	handleFillValueIfEmpty(event: KeyboardEvent, controlName: string, placeholderValue: string | number) {
		if (event.key === '/' && !this.form.get(controlName).value) {
			event.preventDefault();
			this.form.controls[controlName].setValue(placeholderValue || '');
		}
	}
}
